
import MessageSquare from "../../../assets/outline/MessageSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageSquareIcon({ className, dataTestid = "MessageSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
